import React, { useEffect, useState } from "react"
import Layout from "../components/Layout"
import { Helmet } from "react-helmet"
import axios from "axios"
import MessageModal from "./components/common/MessageModal"
import bubbleIcon from "../../static/images/speech-bubble.png"
import RoundedContainer from "../components/RoundedContainer"
import { FibreHeading } from "../components/FibreHeading"
import HowToGetStarted from "./components/WhyPurpleCow"
import WhyPurpleFibre from "./components/WhyPurpleFibre"
import FibreNetwork from "./components/FibreNetwork"
import FasterThanBigGuys from "./components/FasterThanBigGuys"
import RatedMostReliableInternet from "./components/RatedMostReliableInternet"
import WifiThatGetsToEveryRoom from "./components/WifiThatGetsToEveryRoom"
import InTheNewsPurpleFibre from "./components/InTheNewsPurpleFibre"
import LoveYourSwitch from "./components/LoveYourSwitch"
import ReviewsInternet from "./components/ReviewsInternet"
import JoinTheHerdToday from "./components/JoinTheHerdToday"
import BeneitsInternet from "./components/BeneitsInternet"
import CommonQuestions from "../components/CommonQuestions"
import CheckPlans from "./components/CheckPlans"
import WifiInEveryRoom from "./components/WifiInEveryRoom"
import { useSelector } from "react-redux"
import { colorTheme } from "../data/SrtingConstants"
const FrontInternetPage = () => {
  const [plans, setPlans] = useState<any>(null)
  const [messagePopup, setMessagePopup] = useState(false)
  const addressType = useSelector((state: any) => state.form.addressType)

  const PurpleFibreQuestions = [
    {
      id: 1,
      question: "What is Purple Fibre?",
      answer: (
        <span>
          Purple Fibre is Canada’s fastest and most reliable fibre internet.
          Built from the ground up by Purple Cow, we own everything from our
          servers to your home allowing us to deliver speeds 10 times faster
          than the big guys, with the lowest ping rates—all at the best price.
        </span>
      ),
    },
    {
      id: 2,
      question:
        "Are the install appointments a window of time or an exact appointment time?",
      answer: (
        <span>
          We value your time just like we value our own, so all our Purple Fibre
          appointments are set for an exact time. You’ll never have to wait
          around for hours wondering when our team will arrive.
        </span>
      ),
    },
    {
      id: 3,
      question: "How long does it take to get setup with Purple Fibre?",
      answer: (
        <span>
          Our goal is to have you online the same day you order. While this
          isn’t always possible, when you order Purple Fibre online, you can
          select the exact date and time for your installation.
        </span>
      ),
    },
    {
      id: 4,
      question: "Will I have internet when my power goes out?",
      answer: (
        <span>
          We built our network out so if you lose your power however you have a
          home generator running, your internet will continue working.
        </span>
      ),
    },
    {
      id: 5,
      question: "Whose network do you use?",
      answer: (
        <span>
          We built our own network from the ground up. The entire infrastructure
          is owned and operated by Purple Cow, which is why we can offer speeds
          10x faster than the big guys—all while delivering the best customer
          service.
        </span>
      ),
    },
    {
      id: 6,
      question: "Do you have your own technicians, or do you subcontract?",
      answer: (
        <span>
          We have the coolest techs in the coolest vehicles! Ask the techs to
          show you the vehicles Mooing!! The techs work directly with Purple
          Cow, ensuring they show up on time to set up your internet or resolve
          any issues quickly and professionally.
        </span>
      ),
    },
    {
      id: 7,
      question: "Do I have to install the internet myself?",
      answer: (
        <span>
          Nope! We provide Purple Glove Service, handling everything for you so
          you can enjoy a smooth, hassle-free transition.
        </span>
      ),
    },
    {
      id: 8,
      question: "What happens if Purple Fibre is not available in my area?",
      answer: (
        <span>
          If we haven’t reached your area yet, please provide your information
          at this link, and we’ll contact you when it becomes available. If
          there’s strong demand in a specific area, we’ll prioritize bringing
          Purple Fibre there sooner.
        </span>
      ),
    },
  ]

  const EastLinkQuestions = [
    {
      id: 1,
      question: "How long does it take to get turned on?",
      answer:
        "Usually everything is complete within 3-4 business days unless a tech is required. We use local technicians to your area so depending on availability if a tech is required it can take a little longer. Normally a tech is only required if you are in a new construction or if you know there is no coax in your home.",
    },
    {
      id: 2,
      question: "Will the Wifi get everywhere in my home?",
      answer:
        "We provide a Wifi router for free with your system. The router is awesome and sends out both 5G and 2.4G wifi. If you are having trouble getting the wifi all around your home there are several trouble shooting steps we can work with you on to make sure it works great in your home.",
    },
    {
      id: 3,
      question: "Can I adjust my packages?",
      answer:
        "Super easy to adjust your package. Just shoot us a text and we will make any changes you like.",
    },
    {
      id: 4,
      question: "Do I need the Gig internet plan?",
      answer:
        "Every herd member is different however most of the time the Gig plan provides more bandwidth than you need. We always suggest starting on a lower package and working your way up if needed.",
    },
    {
      id: 5,
      question: "With prices starting at $60 is the internet any good?",
      answer:
        "Our Internet is great. Check out our google reviews if you don't believe us. It is the same internet as the big guys only less expensive.",
    },
  ]

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios(
          process.env.GATSBY_PRODUCT_CATALOG_S3_BUCKET +
            "/snapshots/latest/services/internet/plans.json"
        )
        setPlans(response.data)
      } catch (err) {
        console.error("Failed to fetch internet plans:", err)
      }
    }
    fetchData()
  }, [])

  return (
    <Layout>
      <Helmet>
        <title>Internet – Purple Cow Internet 💜🐄</title>
      </Helmet>
      <div className="md:mx-10">
        {/* Check Plans */}
        <CheckPlans plans={plans} />

        {/* show these component if address is PurpleCow */}
        {addressType === "PurpleCow" && (
          <>
            <WhyPurpleFibre />
            <FibreNetwork />
            <FasterThanBigGuys />
            <RatedMostReliableInternet />
            <WifiThatGetsToEveryRoom />
            <InTheNewsPurpleFibre />
            <CommonQuestions questions={PurpleFibreQuestions} />
          </>
        )}

        {addressType === "Eastlink" && (
          <>
            <BeneitsInternet />
            <WifiInEveryRoom />
            <CommonQuestions
              bgColor={colorTheme.MEDIUM_PURPLE}
              questions={EastLinkQuestions}
            />
          </>
        )}

        {/* Why Purple Cow vs the big telcos? */}
        <RoundedContainer className="mt-5" bgColor="white">
          <div className="flex justify-center">
            <FibreHeading
              color="black"
              align="text-center"
              content={"Why Purple Cow vs the big telcos?"}
              className="my-5 md:w-[70%]"
            />
          </div>
          <HowToGetStarted
            steps={[
              "We are local and we honestly care about your experience",
              "Purple Cow actually cares, responds quickly, and treats customers like part of the herd — like real people, not account numbers.",
              "Love us or get your money back. If you’re not completely in love with Purple Cow after your first month, we’ll refund 100% of your money — no questions asked.",
            ]}
          />
        </RoundedContainer>

        {/* Love Your Switch, Or It’s Free! */}
        <LoveYourSwitch />

        {/* Reviews */}
        <ReviewsInternet />

        {/* JOIN THE HERD TODAY */}
        <JoinTheHerdToday
          buttonContent={
            addressType === "" ? (
              <>Check availability &gt;</>
            ) : (
              <>Join the herd</>
            )
          }
        />
      </div>

      <div className="contact-us-parent">
        <div
          className="contact-click-box"
          onClick={(e) => {
            const isMobile = /iPhone|iPad|iPod|Android/i.test(
              navigator.userAgent
            )
            if (isMobile) {
              e.preventDefault() // Prevent the default anchor click behavior
              window.location.href =
                "sms:1-902-800-2660?body=Hey%20Purple%20Cow%20I%20have%20a%20question.%20"
            } else {
              // Open the existing popup on other devices
              setMessagePopup(true)
            }
          }}
        >
          <img src={bubbleIcon} alt="bubble" className="bubble-icon" />
        </div>
      </div>
      {messagePopup ? (
        <MessageModal closepopup={setMessagePopup}></MessageModal>
      ) : null}
    </Layout>
  )
}

export default FrontInternetPage
